import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import logo from "./image/final-3d-logo.jpeg";
import { Link, Outlet } from "react-router-dom";
import "./Nav.css";
function nav() {
  return (
    <>
      <Navbar
        collapseOnSelect
        expand="lg"
        className="bg"
        id="back"
        sticky="top"
      >
        <Navbar.Toggle aria-controls="responsive-navbar-nav" className="menu" />
        <Container>
          <Navbar.Brand className="logo_menu">
            <img className="img-fluid" src={logo} alt="..." />
          </Navbar.Brand>

          <Navbar.Collapse
            fill
            variant="tabs"
            defaultActiveKey="/home"
            id="responsive-navbar-nav"
          >
            <Nav className="me-auto col-lg-12 ">
              <Nav.Link
                activeClassName="active"
                as={Link}
                to="/"
                eventKey="link-1"
              >
                Home
              </Nav.Link>
              <Nav.Link as={Link} to="/About" eventKey="/About">
                About
              </Nav.Link>
              <Nav.Link as={Link} to="/Portfolio" eventKey="/Portfolio">
                Portfolio
              </Nav.Link>

              <Nav.Link as={Link} to="/Service" eventKey="/Service">
                Service
              </Nav.Link>

              <Nav.Link as={Link} to="/Blog" eventKey="/Blog">
                Blog
              </Nav.Link>
              <Nav.Link as={Link} to="/Contact" eventKey="/Contact">
                Contact Us
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Outlet />
    </>
  );
}

export default nav;
